import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { getOrder } from '../../selectors/order/get-order';
import { assertIsOrderCreated } from '../../utils/order-type-utils';
import { registerOrderAction } from '../utils/register-order-action';
/**
 * Loads an [[OrderCompletion]] for the current [[InProgressOrder]].
 */
export const loadOrderCompletion = async () => {
    const order = getOrder();
    assertIsOrderCreated(order, 'Cannot load order completion');
    const deregisterAction = registerOrderAction('load-order-completion');
    try {
        return await ocapiClient.instance.v1.orders.completion.get(order.id);
    }
    finally {
        deregisterAction();
    }
};
